import { useTranslation } from "react-i18next"

import { cn } from "@/lib/cn"
import { localeOf } from "@/lib/format"
import { formatMoney } from "@/lib/money"

/** An XAF amount, through the one formatter (FR-DSH-XCT-06); `null` is "—". */
export function MoneyDisplay({ amount, className }: { amount: number | null; className?: string }) {
  const { i18n } = useTranslation()
  return (
    <span className={cn("numeric whitespace-nowrap", className)}>
      {amount === null ? "—" : formatMoney(amount, localeOf(i18n.language))}
    </span>
  )
}
